import type { TemperatureDemoChoice } from "./temperatureDemoTypes"

/** Look + copy of each scenario choice in the setup dialog (mockup `SCN`). */
export const SCENARIO_LOOK: Record<
  TemperatureDemoChoice,
  { labelKey: string; descKey: string; bg: string; border: string; fg: string; swatch: string }
> = {
  off: {
    labelKey: "temperatureDemo.scenarioOff",
    descKey: "temperatureDemo.scenarioOffDesc",
    bg: "#ffffff",
    border: "1px solid rgba(0,0,0,.18)",
    fg: "#5f6368",
    swatch: "transparent",
  },
  normal: {
    labelKey: "temperatureDemo.scenarioNormal",
    descKey: "temperatureDemo.scenarioNormalDesc",
    bg: "#E8F5E9",
    border: "1px solid #43A047",
    fg: "#1B5E20",
    swatch: "#43A047",
  },
  warning: {
    labelKey: "temperatureDemo.scenarioWarning",
    descKey: "temperatureDemo.scenarioWarningDesc",
    bg: "#FFF4E5",
    border: "1px solid #D97A00",
    fg: "#8A4200",
    swatch: "#D97A00",
  },
  critical: {
    labelKey: "temperatureDemo.scenarioCritical",
    descKey: "temperatureDemo.scenarioCriticalDesc",
    bg: "#B3261E",
    border: "1px solid #B3261E",
    fg: "#ffffff",
    swatch: "#B3261E",
  },
  past: {
    labelKey: "temperatureDemo.scenarioPast",
    descKey: "temperatureDemo.scenarioPastDesc",
    bg: "#EEF2F8",
    border: "1px solid #234285",
    fg: "#234285",
    swatch: "#7B8FBF",
  },
}
